import React from 'react';
import Button from '@carvana/ds-button';
import '@carvana/ds-spinner/styles.css';
import LinkButton from '|/components/carvana-ds/link-button';
import Spinner from '@carvana/ds-spinner';
import styles from '../../gap-coverage.module.css';

interface ActionsProps {
  isApplied: boolean;
  loadError: string | null;
  isSubmitting: boolean;
  handleContinue: () => void;
  handleDecline: () => void;
}

const Actions: React.FC<ActionsProps> = ({
  isApplied,
  loadError,
  isSubmitting,
  handleContinue,
  handleDecline
}) => {
  return (
    <div className={styles.actions}>
      {loadError && <div className={styles.error}>{loadError}</div>}
      {isSubmitting ? (
        <Spinner size={57} />
      ) : (
        <>
          <Button
            onClick={handleContinue}
            size="md"
            width="327px"
            data-analytics-id="gap_coverage_continue"
          >
            {isApplied ? 'Continue' : 'Add GAP coverage'}
          </Button>
          <LinkButton
            variant="default"
            onClick={handleDecline}
            size="md"
            underline={false}
            data-analytics-id="gap_coverage_decline"
          >
            No, thanks
          </LinkButton>
        </>
      )}
    </div>
  );
};

export default Actions;
